<template>
 <el-table
        size="mini"
    :data="tableData"
    height="0"
    stripe
    class="flex-grow-1"
    :class="{'dark':skinType}"
    :row-class-name="(...nu)=>{return skinType?'dark text-white':''}"
  >
    <el-table-column type="index" width="50" label="#" align="center">
    </el-table-column>
    <el-table-column prop="SBName" width="75" label="名称" align="center">
    </el-table-column>
    <el-table-column
      prop="GaoYaCeJinDian"
      width="100"
      label="进电量(kWh)"
      align="center"
    >
    </el-table-column>
    <el-table-column
      prop="DiYaCeChuDian"
      width="100"
      label="出电量(kWh)"
      align="center"
    >
    </el-table-column>
    <el-table-column prop="SunHao" width="110" label="损耗电量(kWh)" align="center">
    </el-table-column>
    <el-table-column prop="SunHaoZhanBi" width="80" label="损耗(%)" align="center">
    </el-table-column>
  </el-table>
</template>

<script>
import { getbianyaqisunhaofenxi } from '../../../api/statistical-analysis/statisticalanalysis';

export default {
  data() {
    return {
      tableData: [],
    };
  },
  props: {
    select: String,
    stockDate: String,
    notice: String,
  },
  watch: {
    select() {
      this.changes();
    },
    notice() {
      this.changes();
    },
  },
  mounted() {
    this.changes();
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    changes() {
      if (!this.select) {
        this.tableData = [];
        return;
      }
      getbianyaqisunhaofenxi({
        StationIdStr: this.select,
        Date: this.notice,
      })
        .then((res) => {
          this.tableData = res;
        })
        .catch((err) => {
          this.tableData = [];
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
table {
  background: #898a8a;
}
</style>
